// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig"; // MSAL instance
import Login from "./components/auth/SigninWidget"; // Your login component
import useAutoLogout from "./components/auth/AutoLogout";
import Details from "./components/pages/Details";
import Dashboard from "./components/pages/Dashboard";
import Summary from "./components/pages/Summary";
import SummaryAll from "./components/pages/SummaryAll";
import Settings from "./components/pages/Settings";
import Notifications from "./components/pages/Notifications";

const App = () => {
  useAutoLogout(); // Automatically logs out after 5 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} /> {/* Home route */}
          <Route path="/details" element={<Details />} /> {/* Home route */}
          <Route path="/dashboard" element={<Dashboard />} /> {/* Home route */}
          <Route path="/summary" element={<Summary />} /> {/* Home route */}
          <Route path="/all-details" element={<SummaryAll />} /> {/* Home route */}
          <Route path="/notifications" element={<Notifications />} /> {/* Home route */}
          <Route path="/settings" element={<Settings />} /> {/* Home route */}

        </Routes>
      </Router>
    </MsalProvider>
  );
};

export default App;
